import { Instance, types } from 'mobx-state-tree';

const PurchasedProgramProduct = types.model('PurchasedProgramProduct', {
	id: types.number,
	name: types.optional(types.string, ''),
});

const ProgramNextPayment = types.model('ProgramNextPayment', {
	sequence: types.optional(types.number, 0),
	status: types.optional(types.string, ''),
	amount: types.optional(types.string, ''),
	currency: types.optional(types.string, ''),
	due_at: types.maybeNull(types.string),
});

const ProgramPurchase = types.model('ProgramPurchase', {
	is_purchased: types.optional(types.boolean, false),
	payment_type: types.optional(types.string, ''),
	status: types.optional(types.string, ''),
	order_id: types.maybeNull(types.number),
	payment_plan_id: types.maybeNull(types.number),
	product: types.maybeNull(PurchasedProgramProduct),
	total_amount: types.optional(types.string, ''),
	paid_amount: types.optional(types.string, ''),
	remaining_amount: types.optional(types.string, ''),
	currency: types.optional(types.string, ''),
	installments_count: types.maybeNull(types.number),
	paid_installments_count: types.maybeNull(types.number),
	remaining_installments_count: types.maybeNull(types.number),
	next_payment: types.maybeNull(ProgramNextPayment),
});

export default ProgramPurchase;

export interface IPurchasedProgramProductModel extends Instance<typeof PurchasedProgramProduct> {}
export interface IProgramNextPaymentModel extends Instance<typeof ProgramNextPayment> {}
export interface IProgramPurchaseModel extends Instance<typeof ProgramPurchase> {}
